import React, { memo, useEffect, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { MdDateRange } from "react-icons/md";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Row } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";

import { capitalizeFirstLetter, formatDate } from "Helper/Converters";
import AuthAPIs from "../../APIs/auth";
import { useSelector } from "react-redux";
import TicketAPIs from "../../APIs/ticket";
import TicketTypesAPIs from "../../APIs/ticket-types";
import StationCodesAPIs from "../../APIs/station-code";
import RegionAPIs from "../../APIs/region";
import { toast } from "react-toastify";
import CustomDatePicker from "Components/CustomDatePicker";
import moment from "moment";

const COMPLETED_TICKETS_OPTIONS = [
  // { value: "", label: "Select" },
  { label: "All", value: "all" },
  { label: "Incompleted", value: false },
  { label: "Completed", value: true },
];

const CANCEL_DATE_OPTIONS = [
  { label: "Canceled", value: "notNull" },
  { label: "Not Cancel", value: null },
];

const SORTING_OPTIONS = [
  { value: "ticket.created_at", label: "Entered Date" },
  {
    value: "ticket.original_compliance_date",
    label: "Original Compliance Date",
  },
  {
    value: "ticket.completed_date",
    label: "Completed Date",
  },
  {
    label: "Assigned Date",
    value: "ticket.assign_date",
  },
  {
    label: "Reassigned Date",
    value: "ticket.re_assign_date",
  },
  {
    label: "Due Date",
    value: "ticket.due_date",
  },
  {
    label: "Partial Complete Date",
    value: "ticket.partial_complete_date",
  },
];

const SearchForm = ({
  setSearchedData,
  setIsLoading,
  filters = {},
  loadDataOnMount = true,
  refresh,
  hiddenElements = [],
  from,
}) => {
  // const isMounted = useRef(false);

  const [checkedItems, setCheckedItems] = useState({});
  const [users, setUsers] = useState([]);
  const { userId, user } = useSelector((state) => state.auth);
  const { department } = useSelector((state) => state.auth);

  const [stationCodes, setStationCodes] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({});
  const [ticketTypes, setTicketTypes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(loadDataOnMount ? true : false);
  const [allowedStationCodes, setAllowedStationCodes] = useState([]);

  //this is for department=="locator"
  const [assigned, setAssigned] = useState(false);
  const [reassigned, setReassigned] = useState(false);

  const validationSchema = Yup.object().shape({
    ticketType: Yup.string(),
    ticketNo: Yup.string(),
    contractor_name: Yup.string(),
    digNearestIntersection: Yup.string(),
    city: Yup.string(),
    typeOfWork: Yup.string(),
  });
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "44px",
    }),
  };

  const dateType = [
    { value: "", label: "Select" },
    { value: "completedDate", label: "Completed Date" },
    { value: "entered_date", label: "Entered Date" },
    { value: "dueDate", label: "Due Date" },
    { value: "assignDate", label: "Assigned Date" },
    { value: "preCompletedDate", label: "Pre Complete Date" },
    { value: "cancelDate", label: "Cancelled Date" },
    { value: "partialCompleteDate", label: "Partial Complete Date" },
    { value: "officeClearDate", label: "Office Clear Date" },
    { value: "sanitaryOfficeClearDate", label: "Sanitary Office Clear" },
    { value: "waterOfficeClearDate", label: "Water Office Clear" },
    {
      value: "waterAndSanitaryOfficeClearDate",
      label: "Water and Sanitary Office Clear",
    },

    // { value: "", label: "Cenceled Date" },
  ];

  const officeClearDateType = [
    { value: "", label: "Select" },
    { value: "completedDate", label: "Completed Date" },
    { value: "entered_date", label: "Entered Date" },
    { value: "dueDate", label: "Due Date" },
    { value: "assignDate", label: "Assigned Date" },
    { value: "cancelDate", label: "Cancelled Date" },
    // { value: "", label: "Cenceled Date" },
  ];

  const reAssignDateType = [
    { value: "", label: "Select" },
    { value: "completedDate", label: "Completed Date" },
    { value: "entered_date", label: "Entered Date" },
    { value: "dueDate", label: "Due Date" },
    { value: "assignDate", label: "Assigned Date" },
    { value: "CancelledDate", label: "Cancelled Date" },
  ];

  const assignDateType = [
    { value: "", label: "Select" },
    { value: "entered_date", label: "Entered Date" },
    { value: "dueDate", label: "Due Date" },
  ];

  const getAllStationCodes = async () => {
    const stations = JSON.parse(localStorage.getItem("user"));
    const stationCodes = await StationCodesAPIs.getStationCode();
    setStationCodes(
      stationCodes?.data?.data
        ?.filter((item) => item.isFilterable)
        .sort((a, b) => a.name.localeCompare(b.name)) || [],
    );

    setAllowedStationCodes(stations?.allowedStations || []);
  };

  const getAllTicketTypes = async () => {
    const types = await TicketTypesAPIs.getTicketType();

    const customArr = [{ value: "", label: "Select" }];
    if (types) {
      const arr = [...types.data.data];
      arr?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.name}`,
        };
        customArr.push(data);
      });
      setTicketTypes(customArr);
    }
  };

  const getAllRegions = async () => {
    const res = await RegionAPIs.getRegion();

    const customArr = [{ value: "", label: "Select" }];
    if (res) {
      const arr = [...res.data.data];
      arr?.forEach((item) => {
        const data = {
          value: `${item?.name}`,
          label: `${capitalizeFirstLetter(item?.name?.toLowerCase())} Region`,
        };
        customArr.push(data);
      });
      setRegions(customArr);
    }
  };

  const submitHandler = async (values) => {
    let validFilters = { ...filters };
    // if (isMounted.current) {
    //  setIsLoading(true);
    // }

    for (const key of Object.keys(values)) {
      if (values[key] !== "" && values[key] !== null) {
        validFilters[key] = values[key];
      }
    }
    if (values.dateType || values.fromDate) {
      if (!values.dateType || !values.fromDate) {
        toast.error("Please Select Date Type and Start Date atleast ");

        return;
      }
    }

    if (
      !values.fromDate &&
      !values.toDate &&
      Object.keys(validFilters).length == 0
    ) {
      // add in filters fromDate 14 days before
      // add in filters toDate today
      validFilters.fromDate = new Date(
        new Date().getTime() - 14 * 24 * 60 * 60 * 1000,
      )
        .toISOString()
        .split("T")[0];
      validFilters.toDate = new Date().toISOString().split("T")[0];
    }
    // validFilters = Object.entries(validFilters).filter(
    //   ([key, value]) => value !== "" && value !== null
    // );
    // validFilters = Object.fromEntries(validFilters);

    //if other than admin
    const deptName = (department?.name ?? "").toLowerCase();

    // true if dept name contains the standalone word "client" (client, halton-client, halton client)
    const hasClientWord = /\bclient\b/i.test(deptName);
    if (
      user.role === "user" &&
      deptName !== "admin" &&
      deptName !== "manager" &&
      !hasClientWord &&
      department?.name !== "Supervisor" &&
      !validFilters.reAssignTo
    ) {
      validFilters.assignTo = userId;
      validFilters.reAssignTo = userId;
    }

    if (department.name == "client" && validFilters.stationCodes.length == 0) {
      alert(`Select at least one station code.`);
      return;
    }

    if (department.name == "Halton-Client") {
      validFilters.region = "Halton";
    }

    // if (validFilters.stationCodes && !(validFilters.stationCodes?.length > 0)) {
    //   delete validFilters.stationCodes; // Adjust based on your backend's expected format
    // }

    if (validFilters.dateType == "completedDate") {
      delete validFilters.completedDate; // Adjust based on your backend's expected format
    }

    if (validFilters.stationCodes?.length == 0) {
      delete validFilters.stationCodes;
    }

    if (values.fromDate)
      validFilters.fromDate = moment(values.fromDate).format("YYYY-MM-DD");

    if (values.toDate)
      validFilters.toDate = moment(values.toDate).format("YYYY-MM-DD");

    setCurrentFilters(validFilters); // Update current filters
    setLoading(true);
    const search = await TicketAPIs.search(validFilters);
    if (search) {
      const customArr = [];
      let filteredData = [...search.data.data];
      setSearchedData(filteredData);
    } else {
      setSearchedData([]);
    }
    setLoading(false);
  };

  const PreSelectStationCodes = ({ setFieldValue }) => {
    useEffect(() => {
      if (department?.name === "client") {
        const allowedStationIds = stationCodes
          .filter((station) => allowedStationCodes.includes(station.name))
          .map((station) => station.id);

        // Set the selected station codes in Formik
        setFieldValue("stationCodes", allowedStationIds);
        setFieldValue("completedDate", COMPLETED_TICKETS_OPTIONS[1].value);
      }
    }, []);

    return null; // Nothing is rendered, just sets values
  };

  /**
   * Get All Users.
   */
  const getUsers = async () => {
    // setIsLoading(true);
    const users = await AuthAPIs.getAllUsers();
    const customArr = [];
    if (users) {
      users.data?.data?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
        // Only include active users and exclude current user
        if (item?.id !== userId && item?.isActive === true) {
          customArr.push(data);
        }
      });
      customArr.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setUsers([{ value: "", label: "Select" }, ...customArr]);
    }
    //setIsLoading(false);
  };

  const stationOptions = stationCodes
    .filter((option) => allowedStationCodes.includes(option?.name))
    .map((option) => ({
      value: option.id,
      label: option.name,
    }));

  useEffect(() => {
    // Perform initial data fetching

    const fetchData = async () => {
      return await Promise.all([
        getUsers(),
        getAllStationCodes(),
        getAllTicketTypes(),
        getAllRegions(),
      ]);
      // Additional initial data fetching logic here
    };

    fetchData().then(() => {
      // After fetching initial data, check if we should load data on mount
      if (loadDataOnMount) {
        submitHandler({
          fromDate: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
          toDate: new Date(),
          dateType: dateType[2].value,
          sortBy: "ticket.created_at",
          sortOrder: window.location.pathname.includes("office-clear")
            ? "ASC"
            : "DESC",
          // completedDate: COMPLETED_TICKETS_OPTIONS[1].value,
        });
      }
    });
  }, [loadDataOnMount, refresh]);

  return (
    <Formik
      onSubmit={(values) => {
        submitHandler(values);
      }}
      initialValues={{
        // ticketType: ticketType[0].label,
        ticketNo: "",
        contractor_name: "",
        company_name: "",
        digAddress: "",
        digNearestIntersection: "",
        city: "",
        assignTo: "",
        reAssignTo: "",
        typeOfWork: "",
        fromDate: "",
        toDate: "",
        dateType: dateType[0].value,
        stationCodes: [],
        completedDate: "all",
        // completedDate: COMPLETED_TICKETS_OPTIONS[1].value,
        cancelDate: null,
        sortBy: "ticket.created_at",
        sortOrder: window.location.pathname.includes("office-clear")
          ? "ASC"
          : "DESC",
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        errors,
        setFieldValue,
        resetForm,
      }) => (
        <Form
          className="dashboard-form mb-4"
          noValidate
          onSubmit={handleSubmit}
        >
          <PreSelectStationCodes setFieldValue={setFieldValue} />
          <Row>
            {!hiddenElements.includes("ticketNo") && (
              <Col md={6}>
                <Form.Group className="form-group">
                  <Form.Label>Ticket Number</Form.Label>
                  <Form.Control
                    type="text"
                    name={"ticketNo"}
                    onChange={handleChange}
                    value={values.ticketNo}
                  />
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("contractor_name") && (
              <Col md={3}>
                <Form.Group className="form-group">
                  <Form.Label>Contractor</Form.Label>
                  <Form.Control
                    type="text"
                    name={"contractor_name"}
                    onChange={handleChange}
                    value={values.contractor_name}
                  />
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("company_name") && (
              <Col md={3}>
                <Form.Group className="form-group">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    type="text"
                    name={"company_name"}
                    onChange={handleChange}
                    value={values.company_name}
                  />
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("digAddress") && (
              <Col md={3}>
                <Form.Group className="form-group">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name={"digAddress"}
                    onChange={handleChange}
                    value={values.digAddress}
                  />
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("callerName") && (
              <Col md={3}>
                <Form.Group className="form-group">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name={"city"}
                    onChange={handleChange}
                    value={values.city}
                  />
                </Form.Group>
              </Col>
            )}
            {/* {department?.name != 'locator' && !hiddenElements.includes("assignTo") &&
              <Col md={6}>
                <Form.Group className="form-group">
                  <Form.Label>Assigned To</Form.Label>
                  <Select
                    options={users}
                    defaultValue={users[0]}
                    styles={customStyles}
                    value={users.find(
                      (opt) => opt.assignTo === values.assignTo
                    )}
                    onChange={(selectedOption) => {
                      handleChange("assignTo")(selectedOption.value);
                    }}
                  />
                </Form.Group>
              </Col>
            } */}
            {/* <Col md={6}>
              <Form.Group className="form-group">
                <Form.Label>Re-Assigned To</Form.Label>
                <Select
                  options={users}
                  defaultValue={users[0]}
                  styles={customStyles}
                  value={users.find(
                    (opt) => opt.reAssignTo === values.reAssignTo
                  )}
                  onChange={(selectedOption) => {
                    handleChange("reAssignTo")(selectedOption.value);
                  }}
                />
              </Form.Group>
            </Col> */}

            {!hiddenElements.includes("digNearestIntersection") && (
              <Col md={2}>
                <Form.Group className="form-group">
                  <Form.Label>Nearest Intersection</Form.Label>
                  <Form.Control
                    type="text"
                    name={"digNearestIntersection"}
                    onChange={handleChange}
                    value={values.digNearestIntersection}
                  />
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("region") && (
              <Col md={2}>
                <Form.Group className="form-group">
                  <Form.Label>Region</Form.Label>
                  <Select
                    options={
                      department.name == "Halton-Client"
                        ? [{ value: "Halton", label: "Halton Region" }]
                        : regions
                    }
                    styles={customStyles}
                    onChange={(selectedOptions) => {
                      setFieldValue("region", selectedOptions.value);
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.region}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            )}
            {!hiddenElements.includes("typeOfWork") && (
              <Col md={2}>
                <Form.Group className="form-group">
                  <Form.Label>Type Of Work</Form.Label>
                  <Form.Control
                    type="text"
                    name={"typeOfWork"}
                    onChange={handleChange}
                    value={values.typeOfWork}
                  />
                </Form.Group>
              </Col>
            )}

            {/* <Col md={6}>
              <Form.Group className="form-group">
                <Form.Label>Complete/InComplete Text</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col> */}

            {/* <Col md={4}>
              <Form.Group className="form-group">
                <Form.Label>Caller Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col> */}

            {!hiddenElements.includes("sortingOptions") && (
              <Col md={12}>
                <h6>Sorting Options </h6>
                <div className="row">
                  {window.location.pathname.includes("query-search") && (
                    <Col md={2}>
                      <Form.Group className="form-group">
                        <Form.Label>Ticket Status</Form.Label>
                        <Select
                          options={COMPLETED_TICKETS_OPTIONS}
                          styles={customStyles}
                          value={COMPLETED_TICKETS_OPTIONS.find(
                            (opt) => opt.value === values.completedDate,
                          )}
                          onChange={(selectedOptions) => {
                            setFieldValue(
                              "completedDate",
                              selectedOptions.value,
                            );
                          }}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("cancelDate") && (
                    <Col md={2}>
                      <Form.Group className="form-group">
                        <Form.Label>Cancel / Not Cancel</Form.Label>
                        <Select
                          options={CANCEL_DATE_OPTIONS}
                          styles={customStyles}
                          onChange={(selectedOption) => {
                            setFieldValue("cancelDate", selectedOption.value);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("ticketType") && (
                    <Col md={2}>
                      <Form.Group className="form-group">
                        <Form.Label>Ticket Type</Form.Label>
                        <Select
                          options={ticketTypes}
                          styles={customStyles}
                          onChange={(selectedOptions) => {
                            setFieldValue(
                              "ticketType",
                              selectedOptions.label !== "Select"
                                ? selectedOptions.label
                                : "",
                            );
                          }}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.ticketType}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("dateType") && (
                    <Col md={2}>
                      <Form.Group className="form-group mb-0">
                        <Form.Label>Date Type</Form.Label>
                        <Select
                          options={
                            from == "Assign"
                              ? assignDateType
                              : from == "ReAssign"
                                ? reAssignDateType
                                : from == "officeClear"
                                  ? officeClearDateType
                                  : dateType
                          }
                          defaultValue={dateType[0]}
                          styles={customStyles}
                          value={dateType.find(
                            (opt) => opt.value === values.dateType,
                          )}
                          onChange={(selectedOption) => {
                            handleChange("dateType")(selectedOption.value);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("fromDate") && (
                    <Col md={2}>
                      <Form.Group className="form-group mb-0">
                        <Form.Label>Start Date</Form.Label>
                        <div className="datepicker_box">
                          <CustomDatePicker
                            defaultValue
                            selected={values.fromDate}
                            onSelect={(date) =>
                              handleChange({
                                target: { name: "fromDate", value: date },
                              })
                            }
                            value={values.fromDate}
                            dateFormat="MM/dd/yyyy"
                          />
                          <span>
                            <MdDateRange />
                          </span>
                        </div>
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("toDate") && (
                    <Col md={2}>
                      <Form.Group className="form-group">
                        <Form.Label>End Date</Form.Label>
                        <div className="datepicker_box">
                          <CustomDatePicker
                            selected={values.toDate}
                            onSelect={(date) => {
                              handleChange({
                                target: { name: "toDate", value: date },
                              });
                            }}
                            value={values.toDate}
                            dateFormat="MM/dd/yyyy"
                          />
                          <span>
                            <MdDateRange />
                          </span>
                        </div>
                      </Form.Group>
                    </Col>
                  )}
                  {!hiddenElements.includes("stationCodes") && (
                    <Col md={3}>
                      <Form.Group className="form-group">
                        <Form.Label>Station Codes</Form.Label>
                        <Select
                          name="stationCodes"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti
                          styles={customStyles}
                          options={stationOptions}
                          value={stationOptions.filter((opt) =>
                            values.stationCodes.includes(opt.value),
                          )}
                          onChange={(selected) => {
                            const selectedIds = selected
                              ? selected.map((opt) => opt.value)
                              : [];
                            setFieldValue("stationCodes", selectedIds);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  )}

                  {!hiddenElements.includes("assignTo") && (
                    <>
                      <Col md={3}>
                        <Form.Group className="form-group">
                          <Form.Label>
                            {from == "ReAssign"
                              ? "Assigned From"
                              : "Assigned To"}
                          </Form.Label>
                          <Select
                            options={users}
                            defaultValue={users[0]}
                            styles={customStyles}
                            value={users.find(
                              (opt) => opt.assignTo === values.assignTo,
                            )}
                            onChange={(selectedOption) => {
                              handleChange("assignTo")(selectedOption.value);
                              handleChange("reAssignTo")(selectedOption.value);
                            }}
                          />
                        </Form.Group>
                      </Col>
                      {!hiddenElements.includes("reAssignTo") && (
                        <Col md={2}>
                          <Form.Group className="form-group">
                            <Form.Label>Re-Assigned To</Form.Label>
                            <Select
                              options={users}
                              defaultValue={users[0]}
                              styles={customStyles}
                              value={users.find(
                                (opt) => opt.assignTo === values.assignTo,
                              )}
                              onChange={(selectedOption) => {
                                handleChange("reAssignTo")(
                                  selectedOption.value,
                                );
                              }}
                            />
                          </Form.Group>
                        </Col>
                      )}
                    </>
                  )}
                  <Col md={2}>
                    <Form.Group className="form-group">
                      <Form.Label>Sort Order</Form.Label>
                      <Select
                        options={[
                          { value: "ASC", label: "Old to Latest" },
                          { value: "DESC", label: "Latest to Old" },
                        ]}
                        defaultValue={
                          values.sortOrder || {
                            value: "DESC",
                            label: "Latest to Old",
                          }
                        }
                        styles={customStyles}
                        value={{
                          value: values.sortOrder || "DESC",
                          label:
                            (values.sortOrder || "DESC") === "ASC"
                              ? "Old to Latest"
                              : "Latest to Old",
                        }}
                        onChange={(selectedOption) => {
                          handleChange("sortOrder")(selectedOption.value);
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group className="form-group">
                      <Form.Label>Sort By</Form.Label>
                      <Select
                        options={SORTING_OPTIONS}
                        defaultValue={
                          values.sortBy || {
                            value: "ticket.created_at",
                            label: "Entered Date",
                          }
                        }
                        styles={customStyles}
                        value={{
                          value: values.sortBy || "ticket.created_at",
                          label:
                            (values.sortBy || "ticket.created_at") ===
                            "ticket.created_at"
                              ? "Entered Date"
                              : "Completed Date",
                        }}
                        onChange={(selectedOption) => {
                          handleChange("sortBy")(selectedOption.value);
                        }}
                      />
                    </Form.Group>
                  </Col>
                </div>
              </Col>
            )}

            {/*{!hiddenElements.includes("stationCodes") && (*/}
            {/*  <Col md={12}>*/}
            {/*    <Form.Group className="form-group">*/}
            {/*      <Form.Label>Station Codes</Form.Label>*/}
            {/*      <div className="checkboxHolder">*/}
            {/*        {stationCodes*/}
            {/*          .filter((option) =>*/}
            {/*            allowedStationCodes.includes(option?.name)*/}
            {/*          )*/}
            {/*          .map((option) => (*/}
            {/*            <div key={option.id} className={"form-check"}>*/}
            {/*              <Field*/}
            {/*                type="checkbox"*/}
            {/*                className={"form-check-input"}*/}
            {/*                name="stationCodes"*/}
            {/*                value={option?.id}*/}
            {/*                checked={values.stationCodes.includes(option?.id)}*/}
            {/*                onChange={(e) => {*/}
            {/*                  const isChecked = e.target.checked;*/}
            {/*                  setFieldValue(*/}
            {/*                    "stationCodes",*/}
            {/*                    isChecked*/}
            {/*                      ? [...values.stationCodes, option?.id]*/}
            {/*                      : values.stationCodes.filter(*/}
            {/*                          (item) => item !== option?.id*/}
            {/*                        )*/}
            {/*                  );*/}
            {/*                }}*/}
            {/*              />*/}
            {/*              <label key={option.id} className="form-check-label">*/}
            {/*                {" "}*/}
            {/*                {option?.name}*/}
            {/*              </label>*/}
            {/*            </div>*/}
            {/*          ))}*/}
            {/*      </div>*/}
            {/*    </Form.Group>*/}
            {/*  </Col>*/}
            {/*)}*/}

            {department?.name == "locator" && (
              <Col md={12} className="d-flex flex-row mt-3">
                <>
                  <Form.Group className="me-4">
                    <Form.Check
                      type="checkbox"
                      label="Assigned To"
                      name="assignTo"
                      checked={values.assignTo}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        handleChange("assignTo")(isChecked ? userId : "");
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Re-Assigned To"
                      name="reAssignTo"
                      checked={values.reAssignTo}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        handleChange("reAssignTo")(isChecked ? userId : "");
                      }}
                    />
                  </Form.Group>
                </>
              </Col>
            )}

            <Col md={6} className="d-flex position-relative z-1">
              <Button
                type="submit"
                style={{ minHeight: "44px" }}
                disabled={loading}
              >
                <BiSearch />
                {loading ? "Loading..." : "Search"}
              </Button>
              <Button
                onClick={() => {
                  resetForm();
                  setSearchedData([]);
                  setFieldValue("fromDate", null);
                  setFieldValue("toDate", null);
                  setFieldValue("dateType", "");
                  setFieldValue("completedDate", "");
                }}
                style={{
                  minHeight: "44px",
                  marginLeft: "20px",
                  backgroundColor: "red",
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default memo(SearchForm);
